import React from "react";
import Header from "../../components/InternationalAcademy/Header";
import Hero from "../../components/InternationalAcademy/Hero";
import Category from "../../components/InternationalAcademy/Category";
import Founder from "../../components/InternationalAcademy/Founder";
import PreSchool from "../../components/InternationalAcademy/PreSchool";
import PrimarySchool from "../../components/InternationalAcademy/Primary";
import Secondary from "../../components/InternationalAcademy/Secondary";
import Curricular from "../../components/InternationalAcademy/Curricular ";
import Facilities from "../../components/InternationalAcademy/Facilities";
import Instagram from "../../components/InternationalAcademy/Instagram";
import Footer from "../../components/InternationalAcademy/Footer";
// import "./styles.css";

const InternationalAcademy = () => {
  return (
    <div className="scroll scroll-auto transition-all">
      <Header />
      <Hero />
      <Category />
      <Founder />
      <PreSchool />
      <PrimarySchool />
      <Secondary />
      <Curricular />
      <Facilities />
      <Instagram />
      <Footer />
    </div>
  );
};

export default InternationalAcademy;
